import { h } from 'preact'

export default function studyRewardNotificationLevelView ({ levelChanged, newLevel }) {
  return levelChanged && h('div', {
    class: 'reward-notification good'
  }, `Ding! You just hit level ${newLevel}! 👑`)
}
